import classNames from "classnames";
import React from "react";

import { usePages } from "../../../hooks/usePages";
import styles from "./index.module.scss";
import { Icon } from "../../atoms/icon";

interface Props {
  currentPage?: number;
  onChange?: (newPage: number) => void;
  pages?: number;
  indeterminate?: boolean;
  hasNext?: boolean;
}

const Pager: React.FC<Props> = ({
  currentPage = 1,
  onChange,
  pages = 1,
  indeterminate = false,
  hasNext = false,
}) => {
  const { safeCurrentPage, displayedPages } = usePages(
    currentPage,
    pages,
    indeterminate,
  );
  console.log("hasNext", !indeterminate || hasNext);

  return (
    <div className={styles.pager}>
      <div
        className={classNames(
          styles.arrow,
          safeCurrentPage === 1 ? styles.inactive : null,
          styles.left,
        )}
      >
        <div
          onClick={
            onChange && safeCurrentPage !== 1
              ? () => onChange(safeCurrentPage - 1)
              : undefined
          }
        >
          <Icon
            color={safeCurrentPage === 1 ? "black10" : "accent"}
            name="arrow_left"
            size="large"
          />
        </div>
      </div>
      <div className={styles.pages}>
        {displayedPages.map((page, index) => (
          <div
            key={index}
            className={classNames(styles.page, {
              [styles.separator]: page === -1,
              [styles.current]: page === safeCurrentPage,
            })}
            onClick={
              onChange && page !== -1 && page !== safeCurrentPage
                ? () => onChange(page)
                : undefined
            }
          >
            {page === -1 ? "..." : page}
          </div>
        ))}
      </div>
      <div
        className={classNames(
          styles.arrow,
          (!indeterminate || !hasNext) && safeCurrentPage >= pages
            ? styles.inactive
            : null,
          styles.right,
        )}
      >
        <div
          onClick={
            onChange && ((indeterminate && hasNext) || safeCurrentPage < pages)
              ? () => onChange(safeCurrentPage + 1)
              : undefined
          }
        >
          <Icon
            color={
              (!indeterminate || !hasNext) && safeCurrentPage >= pages
                ? "black10"
                : "accent"
            }
            name="arrow_right"
            size="large"
          />
        </div>
      </div>
    </div>
  );
};

export { Pager };
